import { useTranslation } from 'react-i18next'
import HelpTooltipIcon from '../../../../components/HelpTooltipIcon'
import { formatThousands } from '../../../../utils/formatNumber'
import BasicWidget from '../../Stats/components/widgets/BasicWidget'
import { useCountersAnalyticsData } from '../../analytics/hooks/use-counters-analytics-data'

const TotalCardsWidget = () => {
  const { t } = useTranslation()
  const { headlineStats, isLoading } = useCountersAnalyticsData()

  return (
    <BasicWidget
      title={formatThousands(headlineStats.cardsUsed)}
      subtitle={t('stats.totalCards')}
      iconRight={<HelpTooltipIcon text={t('stats.tooltips.totalCards')} />}
      isLoading={isLoading}
    />
  )
}

export default TotalCardsWidget
